import {CONFIG_URL,checkedConfig,enabled,sameSelection} from '../aplus-wechat-contract';
import {peekAplusWechat,subscribeAplusWechat} from './aplus-wechat-preload';

const listeners=new Set();
let policy=null,latest=null,flight=null,poll=null,expiry=null,stopPreload=null;
const now=()=>Date.now();
function emit(){for(const fn of listeners){try{fn(getAplusWechatPolicy());}catch(_){/* One view cannot prevent other policy consumers updating. */}}}
function accept(value){
 if(value&&latest&&value.revision<latest.revision)return;
 if(value&&latest&&value.revision===latest.revision&&['enabled','ready','configured','currency','minAmountMinor','maxAmountMinor','apiBaseUrl'].some(key=>value[key]!==latest[key]))value=null;
 if(value)latest=value;
 policy=value;clearTimeout(expiry);
 if(value)expiry=setTimeout(()=>{emit();},Math.max(0,value.expiresAt-now())+1);
 emit();
}
export function getAplusWechatPolicy(){return policy&&policy.expiresAt>now()?policy:null;}
export function refreshAplusWechatPolicy(){
 if(flight)return flight;
 const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
 flight=(async()=>{
  try{
   const response=await fetch(CONFIG_URL,{method:'GET',mode:'cors',credentials:'omit',cache:'no-store',redirect:'error',signal:controller.signal});
   if(!response.ok)throw new Error('WECHAT_POLICY_UNAVAILABLE');
   const value=checkedConfig(await response.json(),now());
   if(value.minAmountMinor<600||value.maxAmountMinor>80000)throw new Error('WECHAT_POLICY_RANGE');
   accept(value);return getAplusWechatPolicy();
  }catch(_){accept(null);return null;}
  finally{clearTimeout(timer);flight=null;}
 })();return flight;
}
export function subscribeAplusWechatPolicy(listener){
 listeners.add(listener);
 if(listeners.size===1){
  stopPreload=subscribeAplusWechat(event=>{if(event&&event.config){try{const value=checkedConfig({aplusWechat:event.config},now());if(value.minAmountMinor>=600&&value.maxAmountMinor<=80000)accept(value);}catch(_){/* Unusable cache does not activate a method. */}}else emit();});
  poll=setInterval(()=>{if(typeof document==='undefined'||document.visibilityState!=='hidden')refreshAplusWechatPolicy();},10000);
  if(typeof window!=='undefined')window.addEventListener('focus',refreshAplusWechatPolicy);
  refreshAplusWechatPolicy();
 }
 return ()=>{listeners.delete(listener);if(!listeners.size){clearInterval(poll);clearTimeout(expiry);stopPreload?.();stopPreload=null;if(typeof window!=='undefined')window.removeEventListener('focus',refreshAplusWechatPolicy);}};
}
export function isAplusWechatAmountEligible(amountMinor,value=getAplusWechatPolicy(),at=now()){
 return !!value&&enabled(value,at)&&value.currency==='CNY'&&Number.isSafeInteger(amountMinor)&&amountMinor>=600&&amountMinor<=80000
  &&amountMinor>=value.minAmountMinor&&amountMinor<=value.maxAmountMinor;
}
export function paymentMethodFamilies(methods){
 const set=new Set((Array.isArray(methods)?methods:[]).map(method=>method==='aplus_wechat'?'wechat':method));
 return ['alipay','wechat','visa'].filter(method=>set.has(method));
}
export function cnyMinor(value){
 if(!['number','string'].includes(typeof value)||!/^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/.test(String(value)))return null;
 const [whole,decimal='']=String(value).split('.'),minor=Number(whole)*100+Number((decimal+'00').slice(0,2));
 return Number.isSafeInteger(minor)&&minor>0?minor:null;
}
export function selectedWechatProduct(product){return product?.cmsOffer?{...product,...product.cmsOffer}:product;}
export function isAplusWechatSnapshotEligible(product,currency,discount,snapshot,value=getAplusWechatPolicy(),at=now()){
 const selected=selectedWechatProduct(product),quote=snapshot?.quote,config=snapshot?.config;
 if(!selected||!['CNY','RMB'].includes(currency)||!discount||!quote||!config||!value||!snapshot.image)return false;
 const excluded=selected.closeprovider;
 if((Array.isArray(excluded)||typeof excluded==='string')&&excluded.includes('aplus_wechat'))return false;
 const amount=cnyMinor(selected.prices?.[currency]??selected.prices?.CNY);
 return amount!==null&&isAplusWechatAmountEligible(amount,value,at)&&enabled(config,at)&&config.revision===value.revision&&config.apiBaseUrl===value.apiBaseUrl
  &&snapshot.catalog?.enabled===true&&snapshot.catalog.expiresAt>at&&quote.expiresAt>at&&quote.currency==='CNY'&&quote.packageCurrency==='CNY'
  &&quote.amountMinor===amount&&quote.packageAmountMinor===amount&&sameSelection(quote,selected)&&quote.policyRevision===value.revision
  &&quote.discountMode===discount.mode&&snapshot.discount?.mode===discount.mode&&(!selected.cmsPricing||selected.cmsPricing.mode===discount.mode);
}
export function hasAplusWechatAvailability(identity,product,currency,discount){
 const selected=selectedWechatProduct(product);
 return isAplusWechatSnapshotEligible(selected,currency,discount,peekAplusWechat(identity,selected));
}
